// Single source of truth for attendance-day status colors. Every screen that renders a
// Present/Half Day/Leave/Holiday/Weekly Off/Missing day should pull from here instead of
// hardcoding its own color, so e.g. "Holiday" always reads as the same color everywhere.
export const ATTENDANCE_COLORS = {
  present: { bg: '#ecfdf5', text: '#047857', dot: '#10b981' },
  halfday: { bg: '#fff7ed', text: '#c2410c', dot: '#f97316' },
  leave: { bg: '#eff6ff', text: '#1d4ed8', dot: '#3b82f6' },
  holiday: { bg: '#eef2ff', text: '#4338ca', dot: '#6366f1' },
  weekend: { bg: '#f1f5f9', text: '#64748b', dot: '#94a3b8' },
  missing: { bg: '#fff1f2', text: '#be123c', dot: '#f43f5e' },
} as const;

export type AttendanceDayKind = keyof typeof ATTENDANCE_COLORS;
